'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _permissionUtil = require('../../../../../common/permissions/permissionUtil');

require('./BoardWriteStatus.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoardWriteStatus = function BoardWriteStatus(_ref) {
    var userPermissions = _ref.userPermissions;

    if (!(0, _permissionUtil.canWrite)(userPermissions)) {
        return _react2.default.createElement(
            'div',
            { className: 'BoardWriteStatus' },
            _react2.default.createElement(
                'span',
                { className: 'status-type' },
                _react2.default.createElement(_Icon2.default, { name: 'board-locked' }),
                ' Read only'
            )
        );
    }

    if (!(0, _permissionUtil.canSave)(userPermissions)) {
        return _react2.default.createElement(
            'div',
            { className: 'BoardWriteStatus' },
            _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    'span',
                    { className: 'status-type' },
                    _react2.default.createElement(_Icon2.default, { name: 'board-shared-users' }),
                    ' Demo board'
                ),
                ' your changes won\'t be saved'
            )
        );
    }

    return null;
};

BoardWriteStatus.propTypes = {
    userPermissions: _propTypes2.default.number
};

exports.default = BoardWriteStatus;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/BoardWriteStatus.js
// module id = 2190
// module chunks = 0